import type { TaskCounts } from '../../school_panel/api/types';

export function taskChips(t: { kind: 'exam' | 'notice'; due_at: string | null; counts: TaskCounts | null }, now: Date = new Date()): string[] {
  const c = t.counts;
  if (!c) return [];
  if (t.kind === 'notice') return [`${c.read ?? 0}/${c.audience} read`];
  if (c.audience === 0) return ['No audience'];
  const out = [`${c.done ?? 0}/${c.audience} done`];
  if ((c.late ?? 0) > 0) out.push(`${c.late} late`);
  if (t.due_at && new Date(t.due_at) > now) out.push('Not due yet');
  else if ((c.missing ?? 0) > 0) out.push(`${c.missing} missing`);
  return out;
}
